export const enumServerType = Object.freeze({
  MySql: 1,
  SystemLog: 2,
  ProcessedLog: 3
})